module.exports = "\n<div [hidden]=\"!loading\">\n    <mat-progress-bar mode=\"indeterminate\" color=\"warn\"></mat-progress-bar>\n</div>\n"